/**
 * Toggle the given class on the given element. Necessary because IE11 does not support the force
 * flag.
 *
 * @param className Class to toggle.
 * @param element Element to toggle the class on.
 * @param force Boolean that indicates if the class should be added or removed.
 */
export function toggleClass(className: string, element: HTMLElement, force?: boolean): void {
  if (force === true) {
    element.classList.add(className);
  } else if (force === false) {
    element.classList.remove(className);
  } else {
    element.classList.toggle(className);
  }
}
